/**
 * Eén rustige badge per week in de weekkop (vervangt het losse ⛔/⚠️/✅-icoontje,
 * Joris 6 okt 2026): rood "3 over max", oranje "2 op max" / "1 volle agenda",
 * en een stille grijze tekst als de week binnen de regels past. Hover = korte
 * samenvatting, klik = het week-check-paneel onder de weekkop open- of dichtklappen
 * (inline sinds 13 okt: de popover lag over de draaidagen heen).
 */
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { weekBadge, weekBadgeUitleg } from './regelMarkering';

const TONEN = {
  rood: { bg: '#fee2e2', fg: '#b91c1c', rand: '#fecaca' },
  oranje: { bg: '#fff7ed', fg: '#b45309', rand: '#fed7aa' },
};

export default function WeekRegelBadge({ wc, onOpen, weekLabel = '', open = false, paneelId }) {
  if (!wc) return null;
  const badge = weekBadge(wc);
  const toon = badge ? TONEN[badge.toon] : null;
  const tekst = badge ? badge.tekst : 'binnen de regels';
  return (
    <Tooltip title={open ? '' : weekBadgeUitleg(wc)} arrow
      componentsProps={{ tooltip: { sx: { whiteSpace: 'pre-line', fontSize: '0.75rem' } } }}>
      <Box component="button" type="button"
        data-testid="week-regel-badge"
        aria-label={`Planningsregels ${weekLabel}: ${tekst}`.replace(/\s+/g, ' ')}
        aria-expanded={open}
        aria-controls={open ? paneelId : undefined}
        onClick={(e) => { e.stopPropagation(); onOpen?.(e.currentTarget); }}
        sx={{
          font: 'inherit', cursor: 'pointer', border: 0, m: 0, lineHeight: 1.2, whiteSpace: 'nowrap',
          display: 'inline-flex', alignItems: 'center', gap: 0.5, alignSelf: 'center',
          ...(toon
            ? { px: 1, py: 0.25, borderRadius: 10, bgcolor: toon.bg, color: toon.fg,
                boxShadow: `inset 0 0 0 1px ${toon.rand}`, fontSize: '0.75rem', fontWeight: 800 }
            : { px: 0.5, py: 0.25, borderRadius: 1, bgcolor: 'transparent', color: '#94a3b8',
                fontSize: '0.72rem', fontWeight: 600 }),
          '&:hover': { filter: 'brightness(0.97)', textDecoration: toon ? 'none' : 'underline' },
          '&:focus-visible': { outline: '2px solid #6366f1', outlineOffset: 2 },
        }}>
        {toon && (
          <Box component="span" aria-hidden
            sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: toon.fg, flexShrink: 0 }} />
        )}
        {tekst}
        <Box component="span" aria-hidden sx={{ fontSize: '0.65rem', opacity: 0.7 }}>{open ? '▴' : '▾'}</Box>
      </Box>
    </Tooltip>
  );
}
